<template>
  <div>
    <card>
        <h1>RIASSUNTO ANTIRICICLAGGIO</h1>
        <div class="row">
            <div class="col">
                <table class="table" v-if="rischio.TAB_A != null">
                    <thead>
                    <tr>
                        <th>TABELLA A</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>A1</td>
                            <td>{{rischio.TAB_A.A1}}</td>
                        </tr>
                        <tr>
                            <td>A2</td>
                            <td>{{rischio.TAB_A.A2}}</td>
                        </tr>
                        <tr>
                            <td>A3</td>
                            <td>{{rischio.TAB_A.A3}}</td>
                        </tr>
                        <tr>
                            <td>A4</td>
                            <td>{{rischio.TAB_A.A4}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col">
                <table class="table" v-if="rischio.TAB_B != null">
                    <thead>
                    <tr>
                        <th>TABELLA B</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>B1</td>
                            <td>{{rischio.TAB_B.B1}}</td>
                        </tr>
                        <tr>
                            <td>B2</td>
                            <td>{{rischio.TAB_B.B2}}</td>
                        </tr>
                        <tr>
                            <td>B3</td>
                            <td>{{rischio.TAB_B.B3}}</td>
                        </tr>
                        <tr>
                            <td>B4</td>
                            <td>{{rischio.TAB_B.B4}}</td>
                        </tr>
                        <tr>
                            <td>B5</td>
                            <td>{{rischio.TAB_B.B5}}</td>
                        </tr>
                        <tr>
                            <td>B6</td>
                            <td>{{rischio.TAB_B.B6}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="row">
            <div class="col-4">
                <table class="table table_column">
                    <tr>
                        <td class="table_column">RISCHIO SPECIFICO</td>
                        <td class="table_column">{{rischio.RISCHIO_SPECIFICO}}</td>
                        <!-- <td class="tabella_rischi" style="background:#9ACD32">rischio non significativo
                        </td> -->
                        <!-- <td v-if="" style="background:#FFFF00"></td>  rischio poco significativo -->
                        <!-- <td v-if="" style="background:#FFA500"></td>  rischio abbastanza significativo -->
                        <!-- <td v-if="" style="background:#FF0000"></td>  rischio molto significativo-->
                    </tr>
                    <tr>
                        <td class="table_column">RISCHIO INERENTE</td>
                        <td class="table_column">{{rischio.RISCHIO_INERENTE}}</td>
                    </tr>
                    <tr>
                        <td class="table_column">RISCHIO EFFETTIVO</td>
                        <td class="table_column">{{rischio.RISCHIO_EFFETTIVO}}</td>
                    </tr>
                </table>
            </div>
            <div class="col-8"></div>
        </div>
        <div class="row" v-if="rischio.PRESTAZIONI.length > 0" style="margin-top:10px">
            <div class="col">
                <h3>Elenco delle prestazioni</h3>
                <table class="table" style="text-align:left">
                    <tr>
                        <th class="table_column">Nome prestazione</th>
                        <th class="table_column">Regola condotta AV</th>
                        <th class="table_column">Rischio inerente</th>
                        <th class="table_column">Peso</th>
                    </tr>
                    <tr v-for="(value,index) in rischio.PRESTAZIONI" v-bind:key="index">
                        <td class="table_column">{{value.ANTIRIC_PRESTAZIONE_TIPO.NOME}}</td>
                        <td class="table_column">{{value.ANTIRIC_PRESTAZIONE_TIPO.REGOLA_CONDOTTA_AV}}</td>
                        <td class="table_column">{{value.ANTIRIC_PRESTAZIONE_TIPO.RISCHIO_INERENTE}}</td>
                        <td class="table_column">{{value.ANTIRIC_PRESTAZIONE_TIPO.PESO}}</td>
                    </tr>
                </table>
            </div>
        </div>
    </card>
    <card class="card" style="margin-top:10px">
        <h3 style="margin-left:15px">Tabella del rischio</h3>
        <div class="row">
            <div class="col-1"></div>
            <div class="col-10">
                <table class="tabella_rischi">
                    <tr class="tabella_rischi">
                        <td rowspan="4" class="tabella_rischi">RISCHIO INERENTE (coefficiente di ponderazione = 30%)</td>
                        <td class="tabella_rischi">Molto significativo 4</td>
                        <td class="tabella_rischi" style="background:#FFFF00;">1.9</td>
                        <td class="tabella_rischi" style="background:#FFA500">2.6</td>
                        <td class="tabella_rischi" style="background:#FFA500">3.3</td>
                        <td class="tabella_rischi" style="background:#FF0000">4</td>
                    </tr>
                    <tr class="tabella_rischi">
                        <td>Abbastanza significativo 3</td>
                        <td class="tabella_rischi" style="background:#FFFF00">1.6</td>
                        <td class="tabella_rischi" style="background:#FFFF00">2.3</td>
                        <td class="tabella_rischi" style="background:#FFA500">3</td>
                        <td class="tabella_rischi" style="background:#FF0000">3.7</td>
                    </tr>
                    <tr>
                        <td class="tabella_rischi">Poco significativo 2</td>
                        <td class="tabella_rischi" style="background:#9ACD32">1.3</td>
                        <td class="tabella_rischi" style="background:#FFFF00">2</td>
                        <td class="tabella_rischi" style="background:#FFA500">2.7</td>
                        <td class="tabella_rischi" style="background:#FFA500">3.4</td>
                    </tr>
                    <tr class="tabella_rischi">
                        <td class="tabella_rischi">Non significativo 1</td>
                        <td class="tabella_rischi" style="background:#9ACD32">1</td>
                        <td class="tabella_rischi" style="background:#FFFF00">1.7</td>
                        <td class="tabella_rischi" style="background:#FFFF00">2.4</td>
                        <td class="tabella_rischi" style="background:#FFA500">3.1</td>
                    </tr>
                    <tr>
                        <td colspan="2" rowspan="2"></td>
                        <td class="tabella_rischi">1<br>non significativo</td>
                        <td class="tabella_rischi">2<br>poco significativo</td>
                        <td class="tabella_rischi">3<br>abbastanza significativo</td>
                        <td class="tabella_rischi">4<br>molto significativo</td>
                    </tr>
                    <tr>
                        <td colspan="4" class="tabella_rischi">RISCHIO SPECIFICO<br>(coefficiente di ponderazione = 70%)</td>
                    </tr>
                </table>
            </div>
            <div class="col-1"></div>
        </div>
        <div class="row" style="margin-top:20px;">
            <div class="col">
                <h3>Profilo di rischio: </h3>
                <ul style="text-align:left">
                    <li><b>IRRILEVANTE</b> da 1 a 1.3,</li>
                    <li><b>BASSO</b> da 1.6 a 2.4,</li>
                    <li><b>MEDIO</b> da 2.7 a 3.4,</li>
                    <li><b>ALTO</b> oltre 3.4.</li>
                </ul>
            </div>
        </div>
        <div class="row" style="margin-left:15px">
            <p>Il profilo di rischio è: <span style="font-weight:bold;text-transform: uppercase;">{{rischio.PROFILO_RISCHIO}}</span>.</p>
        </div>
    
        <div style="margin-right:100px;margin-left:100px;margin-top:30px">
            <!-- <div style="border: 1px solid"> -->
                <div style="border: 1px solid;margin-right:150px;margin-left:150px;text-align:center;margin-bottom:5px;margin-top:10px">
                    <strong>Livelli adeguata verifica</strong>
                </div>
                <div style="margin-right:150px;margin-left:150px;text-align:center;background:#9ACD32" class="row">
                    <div class="col" style="border: 1px solid;">NON SIGNIFICATIVO</div>
                    <div class="col" style="border: 1px solid;">SEMPLIFICATO</div>
                </div>
                <div style="margin-right:150px;margin-left:150px;text-align:center;background:#FFFF00" class="row">
                    <div class="col" style="border: 1px solid;">POCO SIGNIFICATIVO</div>
                    <div class="col" style="border: 1px solid;">SEMPLIFICATO</div>
                </div>
                <div style="margin-right:150px;margin-left:150px;text-align:center;background:#FFA500" class="row">
                    <div class="col" style="border: 1px solid;">ABBASTANZA</div>
                    <div class="col" style="border: 1px solid;">ORDINARIA</div>
                </div>
                <div style="margin-right:150px;margin-left:150px;text-align:center;margin-bottom:10px;background:#FF0000" class="row">
                    <div class="col" style="border: 1px solid;">MOLTO SIGNIFICATIVO</div>
                    <div class="col" style="border: 1px solid;">RAFFORZATA</div>
                </div>
            <!-- </div> -->
        </div>
        <div class="form-row form-group" style="margin-left:15px;margin-top:30px">
            <p>L’adeguata verifica per l’utente è <span style="font-weight:bold;text-transform: uppercase;">{{rischio.ADEGUATA_VERIFICA}}</span>, con periodicità <span style="font-weight:bold">{{rischio.AV_PERIODICITA_MESI}}</span> mesi.</p>
        </div>
        <div class="form-row">
                <h3>Carica AV1</h3>
        </div>
        <div class="form-row form-group">
            <button class="btn float-left" style="font-size:12px;background:#00467f">Scegli file<input class="form-control" type="file" multiple ref="AV1" v-on:change="checkFileUpload('AV1')"></button>
        </div>
        <div class="form-row">
            <h3>Carica AV2</h3>
        </div>
        <div class="form-row form-group">
            <button class="btn float-left" style="font-size:12px;background:#00467f">Scegli file<input class="form-control" type="file" multiple ref="AV2" v-on:change="checkFileUpload('AV2')"></button>
        </div>
        
        <div class="form-row">
            <h3>Carica AV3</h3>
        </div>
        <div class="form-row form-group">
             <button class="btn float-left" style="font-size:12px;background:#00467f">Scegli file<input class="form-control" type="file" multiple ref="AV3" v-on:change="checkFileUpload('AV3')"></button>
        </div>
        <div class="form-row">
            <h3>Carica AV4</h3>
        </div>
        <div class="form-row form-group">
            <button class="btn float-left" style="font-size:12px;background:#00467f">Scegli file<input class="form-control" type="file" multiple ref="AV4" v-on:change="checkFileUpload('AV4')"></button>
        </div>
        <div class="form-row">
            <h3>Carica AV5</h3>
        </div>
        <div class="form-row form-group">
            <button class="btn float-left" style="font-size:12px;background:#00467f">Scegli file<input class="form-control" type="file" multiple ref="AV5" v-on:change="checkFileUpload('AV5')"></button>
        </div>
        <div class="form-row">
            <h3>Carica AV6</h3>
        </div>
        <div class="form-row form-group">
            <button class="btn float-left" style="font-size:12px;background:#00467f">Scegli file<input class="form-control" type="file" multiple ref="AV6" v-on:change="checkFileUpload('AV6')"></button>
        </div>
        <div class="form-row">
            <h3>Carica AV7</h3>
        </div>
        <div class="form-row form-group">
            <button class="btn float-left" style="font-size:12px;background:#00467f">Scegli file<input class="form-control" type="file" multiple ref="AV7" v-on:change="checkFileUpload('AV7')"></button>
        </div>
        <router-link to="dashboard-antiriciclaggio"><button class="btn float-right" type="button" style="margin-top: 20px;margin-right:20px;background:#00467f;">Torna alla home</button></router-link>

        <b-modal v-model="showCheckFile" size="md">
            <template #modal-header="{ close }">
                <b-button size="sm" style="background:#00467f;" @click="close()">X</b-button>
            </template>
            <template>
                <h3 style="color:black; text-align:center; margin-top:15px">Sicuro di voler caricare il documento?</h3>
                <div class="container">
                <div id="preloader_3" v-if="showLoader"></div>
                </div>
            </template>
            <template #modal-footer="{ cancel }">
                <span  v-if="!showLoader" style="padding-left:40px;"><b-button size="sm" variant="danger" @click="cancel()">NO</b-button></span>
                <span  v-if="!showLoader" style="padding-right:40px;"><b-button size="sm"  style="background:#00467f;" @click="handleFileUpload()">SI</b-button></span>
            </template>
        </b-modal>
    
    </card>
  </div>
</template>
<script>
import Card from '@/components/Cards/Card.vue';
import AntiriciclaggioServices from '@/services/AntiriciclaggioServices';
import Services from '@/services/Services';

export default {
    components: {
        Card
    },

    data() {
        return {
            rischio: null,
            // valore_natura_giuridicaA1: 1,
            // valore_attivita_prevalente_svoltaA2: 1,
            // valore_comportamento_tenutoA3: 1,
            // valore_areageografica_residenzaA4: 1,

            // valore_tipologiaB1: 1,
            // valore_modalita_svolgimentoB2: 1,
            // valore_ammontareB3: 1,
            // valore_frequenza_durataB4: 1,
            // valore_ragionevolezzaB5: 1,
            // valore_areageografica_destinazioneB6: 1,
            
            modificaTabella: true,
            valoriTabellaA: null,
            valoriTabellaB: null,
            idTabA: null,
            idTabB: null,
            idPrestazione: null,
            idCliente: null,
            update: null,
            showCheckFile: false,
            showLoader: false,

            value_av: null,
        }
    },

    methods: {
        aggiornaRischio: async function() {
            let errore = 0;
            await AntiriciclaggioServices.updateRischio(this.idCliente, this.update)
            .then(response => { this.rischio= response.data})
            .catch( function (error) {
                if(error.response.status == 401){
                    errore = error.response.status;
                }
            });
            if (errore == 401) {
                let value = await Services.refreshTokenFunction();
                if (value) { await this.aggiornaRischio(); }
            }
            console.log(`rischio:`);
            console.log(this.rischio);
        },

        checkFileUpload: function(value) {
            this.showCheckFile = true;
            this.value_av = value;
        },

        handleFileUpload: async function(){
            this.showLoader = true;
            let token = localStorage.getItem('access_token');
            let risposta;
            let errore = 0;
            // this.file = this.$refs[this.value_av].files[0];
            console.log(`AV = ${this.value_av}`);
            console.log(this.$refs);
            switch(this.value_av) {
                case 'AV1':
                    this.file = this.$refs.AV1.files[0];   
                    break; 
                case 'AV2':
                    this.file = this.$refs.AV2.files[0];   
                    break; 
                case 'AV3':
                    this.file = this.$refs.AV3.files[0];   
                    break;    
                case 'AV4':
                    this.file = this.$refs.AV4.files[0];   
                    break; 
                case 'AV5':
                    this.file = this.$refs.AV5.files[0];   
                    break; 
                case 'AV6':
                    this.file = this.$refs.AV6.files[0];   
                    break; 
                case 'AV7':
                    this.file = this.$refs.AV7.files[0];   
                    break; 
            }
            console.log(this.file);
            let formData = new FormData()
            formData.append('documento', this.file)
            await AntiriciclaggioServices.caricaDocumentoAV(this.idCliente, formData, this.value_av)
            .then(response => { risposta = response.data})
            .catch( function (error) {
                // handle error
                if(error.response.status == 401){
                    errore = error.response.status;
                }
            })
            if (errore == 401) {
                console.log(`errore 401`);
                let value = await Services.refreshTokenFunction();
                if (value) { await this.handleFileUpload(); }
            }
            this.showCheckFile = false;
            this.showLoader = false;
            // await this.getFileCaricati();
        }, 

        main: async function() {
            this.idCliente = this.$route.query.idCliente;
            this.update = this.$route.query.update;
            if (this.$route.query.idCliente != null) {
                await this.aggiornaRischio();
            }
        }
    },
    mounted() {
        this.main();
    },    
};
</script>
<style scoped>

  div{
    font-size:16px
  }

  td{
    font-size:14px;
    

  }
  th {
    font-size:16px,
  }

    .tabella_rischi   {
        border: 1px solid black;
    } 
  
  .table_column {
      border-collapse:collapse;
      border:1px solid #e3e3e3
  }

</style>
